import React, { FormEvent, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { addUser } from "../utils/firebase-actions";
import useKeysPress from "../hooks/useKeysPress";

function Login() {
  const submitBtnRef = React.useRef<HTMLButtonElement>(null);
  const [formData, setFormData] = React.useState({
    clinicName: "",
    name: "",
    phoneNumber: "",
  });
  const navigate = useNavigate();
  const submitAction = useCallback(
    async (e: FormEvent) => {
      e.preventDefault();
      const { clinicName, name, phoneNumber } = formData;
      if (clinicName && name) {
        await addUser(name, clinicName, phoneNumber);
        navigate("/intro");
      }
    },
    [navigate, formData]
  );

  const clickSubmit = useCallback(() => {
    submitBtnRef.current?.click();
  }, []);

  useKeysPress([clickSubmit, clickSubmit, clickSubmit]);
  return (
    <div className="login-container">
      <form onSubmit={submitAction}>
        <input
          type="text"
          placeholder="Name"
          value={formData.name}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          required
        />
        <input
          type="text"
          placeholder="Clinic Name"
          value={formData.clinicName}
          onChange={(e) =>
            setFormData({ ...formData, clinicName: e.target.value })
          }
          required
        />
        <input
          type="tel"
          placeholder="Phone Number"
          value={formData.phoneNumber}
          onChange={(e) =>
            setFormData({ ...formData, phoneNumber: e.target.value })
          }
          required
        />
        <button ref={submitBtnRef}>Submit</button>
      </form>
    </div>
  );
}

export default Login;
